import { API_URL, GETAPI } from "./config";

export const GET_FEATURES = async () => {
  const res = await GETAPI(API_URL.getFeatures);
  return res;
};
